module.exports = {
  // "URL_PROXY_API_BASE_DOMAIN": "http://127.0.0.1:8082",
  // "URL_PROXY_SOCKET_BASE_DOMAIN": "http://127.0.0.1:8082",

  URL_PROXY_API_BASE_DOMAIN: "https://www.westa.com.cn",
  URL_PROXY_SOCKET_BASE_DOMAIN: "https://www.westa.com.cn",
};

global.URL_DEV_PAGE_BASE_DOMAIN = "http://127.0.0.1:8081";
// global.URL_DEV_API_BASE_DOMAIN = "http://192.168.31.40:8082"		//跨域只需要修改这个
global.URL_DEV_API_BASE_DOMAIN = "http://www.westa.com.cn"; //跨域只需要修改这个
global.URL_DEV_SOCKET_BASE_DOMAIN = "http://192.168.31.40:8082"; //跨域只需要修改这个
global.URL_PROD_API_BASE_DOMAIN = "/";
global.URL_PROD_PAGE_BASE_DOMAIN = "https://www.westa.com.cn";
global.URL_PROD_SOCKET_BASE_DOMAIN = "https://www.westa.com.cn";

global.URL_QINIU_UPLOAD = "http://upload-z2.qiniup.com/putb64/-1/";
//global.QINIU_BUCKET = "http://oux5ikubl.bkt.clouddn.com";
global.QINIU_BUCKET = "http://qiniu.westa.com.cn";
global.URL_API_BASE_DOMAIN_TWO = "http://xingliao.s1.natapp.cc";
global.GOOGLE_MAP_JS_API_KEY = "AIzaSyAai07_xXFdgFV1vB7Dwm4G0myz_QzM-h4";
global.UEDITOR_APP_KEY = "59472f5b-dc20-4fcf-ae6d-07b679291994";

global.url_login_page = "/admin/login";
global.url_index_page = "/admin";
global.url_api_common_qiniu_getUpToken = "/api/common/qiniu/getUpToken";
global.url_api_common_geetest_preprocess = "/api/common/geetest/preprocess";
global.url_api_common_userAccount_preprocess = "/api/changdi/app/native/userAccount/login";
global.url_api_admin_native_userAccount_getSms = "/api/changdi/app/native/userAccount/getSms";
global.url_api_admin_native_userTalent_uploadTalentInfo = "/api/changdi/web/userTalent/uploadTalentInfo";
global.url_api_admin_native_userTalent_getMyTalentContract = "/api/changdi/web/userTalent/getMyTalentContract";
global.url_api_admin_native_userTalent_getContractDownloadLink = "/api/changdi/web/userTalent/getContractDownloadLink";

// 官网
// global.url_api_web_websiteAbout_getWebsiteAbout = "/api/changdi/web/websiteAbout/getWebsiteAbout"
// global.url_api_web_websiteIndex_getWebsiteIndex = "/api/changdi/web/websiteIndex/getWebsiteIndex"
global.url_api_web_websiteNews_getWebsiteNews = "/api/changdi/web/websiteNews/getWebsiteNews";
global.url_api_web_websiteNews_getWebsiteNewsBanner = "/api/changdi/web/websiteNews/getWebsiteNewsBanner";
global.url_api_web_websiteContent_getWebsiteContent = "/api/changdi/web/websiteContent/getWebsiteContent";
global.url_api_web_websiteJob_getWebsiteJobs = "/api/changdi/web/websiteJob/getWebsiteJobs";
global.url_api_web_websiteVideoCategory_getWebsiteVideoCategories = "/api/changdi/web/websiteVideoCategory/getWebsiteVideoCategories";
global.url_api_web_websiteVideo_getWebsiteVideos = "/api/changdi/web/websiteVideo/getWebsiteVideos";
global.url_api_web_websiteProductCategory_getWebsiteProductCategories = "/api/changdi/web/websiteProductCategory/getWebsiteProductCategories";
global.url_api_web_websiteProduct_getWebisteProductById = "/api/changdi/web/websiteProduct/getWebisteProductById";
global.url_api_web_websiteProduct_getWebsiteProducts = "/api/changdi/web/websiteProduct/getWebsiteProducts";
global.url_api_web_websiteProduct_getNavWebsiteProducts = "/api/changdi/web/websiteProduct/getNavWebsiteProducts";
global.url_api_web_websiteFix_postWebsiteFix = "/api/changdi/web/websiteFix/postWebsiteFix";
